/*
 * @Author: Tahiti
 * @Date: 2025-08-15 20:53:39
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-20 16:57:49
 * @Description:
 * @FilePath: /weryai-web/locales/modules/login.ts
 */
// 登录多语言配置
export default {
    zh: {
        common_login_register: {
            login: '登录',
            register: '注册',
            google: '使用Google账号登录',
            or: '或',
            email: '邮箱',
            phone: '手机',
            register_code: '请输入邀请码',
        },
        login: {
            welcome: '欢迎回来',
            title1: '请登录以继续',
            password: '密码',
            phone: '手机号',
            areaCode: '区号',
            useEmailPasswordLogin: '邮箱登录',
            usePhoneCodeLogin: '手机号登录',
            detail1: '没有账号？',
            detail2: '立即注册',
            register_code_required: '请输入邀请码',
            register_code_invalid: '请输入正确的邀请码',
        },
        register: {
            createAccount: '创建账户',
            title2: '注册体验AI驱动的营销工具',
            getVerifyCode: '获取验证码',
            verificationCode: '验证码',
            sendCode: '发送验证码',
            continue: '继续',
            detail1: '已有账户？',
            detail2: '立即登录',
            newPassword: '密码',
            confirm: '确认密码',
            confirmCreate: '创建账号',
            trash_can: '如收件箱中没有收到邮件，请到查看垃圾邮件。',
        },
        findPassword: {
            forgotPassword: '忘记密码',
            findBackPassword: '找回密码',
            title: '通过验证码重置密码',
            email: '邮箱',
            sendCode: '发送验证码',
            resetPassword: '重置密码',
            detail1: '已有账户？',
            detail2: '立即登录',
            newPassword: '密码',
            confirm: '确认密码',
            tip: '通过验证码重置密码，每日限5次。',
        },
        rules: {
            email1: '请输入邮箱地址',
            email2: '请输入正确的邮箱地址',
            verifyCode1: '请输入邀请码',
            pwd1: '请输入密码',
            confirmPwd1: '密码不一致',
            password1: '请输入确认密码',
            verifyCode2: '请输入验证码',
            verifyCode3: '请输入正确的验证码',
            password2: '密码不能包含空格',
            password3: '密码长度不对',
            phone1: '请输入手机号',
            phone2: '请输入正确的手机号',
            areaCode1: '请输入国家区号',
            areaCode2: '请输入正确的国家区号',
            email_not_registered: '邮箱未注册',
            login_failed: '登录失败，请稍后重试',
            verifyCode_sent: '验证码已发送，请查收邮件',
            send_failed: '发送失败',
            email_registered: '该邮箱已注册',
            register_success: '注册成功',
            register_failed: '注册失败，请稍后重试',
            reset_password_success: '重置密码成功',
            reset_password_failed: '重置密码失败，请稍后重试',
            login_popup_failed: '无法打开谷歌登录窗口，请重试或检查网络连接',
            login_popup_blocked: '登录弹窗被拦截，请在浏览器中允许弹窗',
            google_login_not_supported: '暂未支持谷歌登录',
        },
    },
    en: {
        common_login_register: {
            login: 'Login',
            register: 'Register',
            google: 'Sign in with Google',
            or: 'OR',
            email: 'Email',
            phone: 'Phone',
            register_code: 'Please enter the invitation code',
        },
        login: {
            welcome: 'Welcome back',
            title1: 'Please sign in to continue',
            password: 'Password',
            phone: 'Phone number',
            areaCode: 'Code',
            detail1: "Don't have an account?",
            detail2: 'Sign up now',
            register_code_required: 'Please enter invitation code',
            register_code_invalid: 'Please enter correct invitation code',
        },
        register: {
            createAccount: 'Create Your Account',
            title2: 'Get started with AI-powered marketing tools today',
            getVerifyCode: 'Get verification code',
            verificationCode: 'Verification code',
            sendCode: 'Send code',
            continue: 'Continue',
            detail1: 'Already have an account?',
            detail2: 'Sign in now',
            newPassword: 'Password',
            confirm: 'Confirm password',
            confirmCreate: 'Create account',
            trash_can:
                "If you don't receive the email in your inbox, please check your spam folder.",
        },
        findPassword: {
            forgotPassword: 'Forgot password',
            findBackPassword: 'Find back password',
            title: 'Reset password through verification code',
            email: 'Email',
            sendCode: 'Send code',
            resetPassword: 'Reset password',
            detail1: 'Already have an account?',
            detail2: 'Sign in now',
            newPassword: 'Password',
            confirm: 'Confirm password',
            tip: 'Reset password through verification code, limited to 5 times per day.',
        },
        rules: {
            email1: 'Please enter email address',
            email2: 'Please enter correct email address',
            verifyCode1: 'Please enter invitation code',
            pwd1: 'Please enter password',
            confirmPwd1: 'Password does not match',
            password1: 'Please enter confirm password',
            verifyCode2: 'Please enter verification code',
            verifyCode3: 'Please enter correct verification code',
            password2: 'Password cannot contain spaces',
            password3: 'Password length is incorrect',
            phone1: 'Please enter phone number',
            phone2: 'Please enter correct phone number',
            areaCode1: 'Please enter country code',
            areaCode2: 'Please enter correct country code',
            email_not_registered: 'Email not registered',
            login_failed: 'Login failed, please try again later',
            verifyCode_sent:
                'Verification code has been sent, please check your email',
            send_failed: 'Send failed',
            email_registered: 'Email already registered',
            register_success: 'Register successfully',
            register_failed: 'Register failed, please try again later',
            reset_password_success: 'Reset password successfully',
            reset_password_failed:
                'Reset password failed, please try again later',
            login_popup_failed:
                'Unable to open Google login window, please try again or check network connection',
            login_popup_blocked:
                'Login popup blocked, please allow pop-ups in your browser',
            google_login_not_supported: 'Google login is not supported yet',
        },
    },
    ja: {
        common_login_register: {
            login: 'ログイン',
            register: '登録',
            google: 'Googleアカウントでログイン',
            or: 'または',
            email: 'メールアドレス',
            register_code: '招待コードを入力してください',
        },
        login: {
            welcome: 'おかえりなさい',
            title1: '続行するにはログインしてください',
            password: 'パスワード',
            detail1: 'アカウントをお持ちでないですか？',
            detail2: '今すぐ登録',
            register_code_required: '招待コードを入力してください',
            register_code_invalid: '正しい招待コードを入力してください',
        },
        register: {
            createAccount: 'アカウントを作成',
            title2: 'AI駆動のマーケティングツールを体験する',
            getVerifyCode: '確認コードを取得',
            verificationCode: '確認コード',
            sendCode: '確認コードを送信',
            continue: '続ける',
            detail1: 'すでにアカウントをお持ちですか？',
            detail2: '今すぐログイン',
            newPassword: 'パスワード',
            confirm: 'パスワードを確認',
            confirmCreate: 'アカウントを作成',
            trash_can:
                '受信トレイにメールが届かない場合は、迷惑メールフォルダを確認してください。',
        },
        findPassword: {
            forgotPassword: 'パスワードを忘れた',
            findBackPassword: 'パスワードを找回',
            title: '確認コードでパスワードをリセット',
            email: 'メールアドレス',
            sendCode: '確認コードを送信',
            resetPassword: 'パスワードをリセット',
            detail1: 'すでにアカウントをお持ちですか？',
            detail2: '今すぐログイン',
            newPassword: 'パスワード',
            confirm: 'パスワードを確認',
            tip: '確認コードでパスワードをリセット、1日5回まで。',
        },
        rules: {
            email1: 'メールアドレスを入力してください',
            email2: '正しいメールアドレスを入力してください',
            verifyCode1: '招待コードを入力してください',
            pwd1: 'パスワードを入力してください',
            confirmPwd1: 'パスワードが一致しません',
            password1: '確認パスワードを入力してください',
            verifyCode2: '確認コードを入力してください',
            verifyCode3: '正しい確認コードを入力してください',
            password2: 'パスワードにスペースを含めることはできません',
            password3: 'パスワードの長さが正しくありません',
            email_not_registered: 'メールアドレスが登録されていません',
            login_failed: 'ログインに失敗しました。後でもう一度お試しください',
            verifyCode_sent: '確認コードを送信しました。メールをご確認ください',
            send_failed: '送信に失敗しました',
            email_registered: 'このメールアドレスは既に登録されています',
            register_success: '登録に成功しました',
            register_failed: '登録に失敗しました。後でもう一度お試しください',
            reset_password_success: 'パスワードのリセットに成功しました',
            reset_password_failed:
                'パスワードのリセットに失敗しました。後でもう一度お試しください',
            login_popup_failed:
                'Googleログインウィンドウを開くことができません。再試行するか、ネットワーク接続を確認してください',
            login_popup_blocked:
                'ログインポップアップがブロックされました。ブラウザでポップアップを許可してください',
            google_login_not_supported:
                'Googleログインはまだサポートされていません',
        },
    },
    ko: {
        common_login_register: {
            login: '로그인',
            register: '회원가입',
            google: 'Google 계정으로 로그인',
            or: '또는',
            email: '이메일',
            register_code: '초대 코드를 입력하세요',
        },
        login: {
            welcome: '다시 오신 것을 환영합니다',
            title1: '계속하려면 로그인하세요',
            password: '비밀번호',
            detail1: '계정이 없으신가요?',
            detail2: '지금 가입하기',
            register_code_required: '초대 코드를 입력하세요',
            register_code_invalid: '올바른 초대 코드를 입력하세요',
        },
        register: {
            createAccount: '계정 만들기',
            title2: 'AI 기반 마케팅 도구를 체험하세요',
            getVerifyCode: '인증 코드 받기',
            verificationCode: '인증 코드',
            sendCode: '인증 코드 보내기',
            continue: '계속',
            detail1: '이미 계정이 있으신가요?',
            detail2: '지금 로그인',
            newPassword: '비밀번호',
            confirm: '비밀번호 확인',
            confirmCreate: '계정 만들기',
            trash_can: '받은편지함에 이메일이 없으면 스팸 폴더를 확인하세요.',
        },
        findPassword: {
            forgotPassword: '비밀번호 찾기',
            findBackPassword: '비밀번호 찾기',
            title: '인증 코드로 비밀번호 재설정',
            email: '이메일',
            sendCode: '인증 코드 보내기',
            resetPassword: '비밀번호 재설정',
            detail1: '이미 계정이 있으신가요?',
            detail2: '지금 로그인',
            newPassword: '비밀번호',
            confirm: '비밀번호 확인',
            tip: '인증 코드로 비밀번호 재설정, 하루 5회 제한.',
        },
        rules: {
            email1: '이메일 주소를 입력하세요',
            email2: '올바른 이메일 주소를 입력하세요',
            verifyCode1: '초대 코드를 입력하세요',
            pwd1: '비밀번호를 입력하세요',
            confirmPwd1: '비밀번호가 일치하지 않습니다',
            password1: '확인 비밀번호를 입력하세요',
            verifyCode2: '인증 코드를 입력하세요',
            verifyCode3: '올바른 인증 코드를 입력하세요',
            password2: '비밀번호에 공백을 포함할 수 없습니다',
            password3: '비밀번호 길이가 올바르지 않습니다',
            email_not_registered: '이메일이 등록되지 않았습니다',
            login_failed: '로그인에 실패했습니다. 나중에 다시 시도하세요',
            verifyCode_sent: '인증 코드가 전송되었습니다. 이메일을 확인하세요',
            send_failed: '전송에 실패했습니다',
            email_registered: '이 이메일은 이미 등록되어 있습니다',
            register_success: '등록에 성공했습니다',
            register_failed: '등록에 실패했습니다. 나중에 다시 시도하세요',
            reset_password_success: '비밀번호 재설정에 성공했습니다',
            reset_password_failed:
                '비밀번호 재설정에 실패했습니다. 나중에 다시 시도하세요',
            login_popup_failed:
                'Google 로그인 창을 열 수 없습니다. 다시 시도하거나 네트워크 연결을 확인하세요',
            login_popup_blocked:
                '로그인 팝업이 차단되었습니다. 브라우저에서 팝업을 허용하세요',
            google_login_not_supported:
                'Google 로그인은 아직 지원되지 않습니다',
        },
    },
    tw: {
        common_login_register: {
            login: '登入',
            register: '註冊',
            google: '使用 Google 帳號登入',
            or: '或',
            email: '信箱',
            register_code: '請輸入邀請碼',
        },
        login: {
            welcome: '歡迎回來',
            title1: '請登入以繼續',
            password: '密碼',
            detail1: '沒有帳號？',
            detail2: '立即註冊',
            register_code_required: '請輸入邀請碼',
            register_code_invalid: '請輸入正確的邀請碼',
        },
        register: {
            createAccount: '建立帳號',
            title2: '註冊體驗 AI 驅動的行銷工具',
            getVerifyCode: '取得驗證碼',
            verificationCode: '驗證碼',
            sendCode: '發送驗證碼',
            continue: '繼續',
            detail1: '已有帳號？',
            detail2: '立即登入',
            newPassword: '密碼',
            confirm: '確認密碼',
            confirmCreate: '建立帳號',
            trash_can: '若收件匣未收到郵件，請查看垃圾郵件。',
        },
        findPassword: {
            forgotPassword: '忘記密碼',
            findBackPassword: '找回密碼',
            title: '透過驗證碼重設密碼',
            email: '信箱',
            sendCode: '發送驗證碼',
            resetPassword: '重設密碼',
            detail1: '已有帳號？',
            detail2: '立即登入',
            newPassword: '密碼',
            confirm: '確認密碼',
            tip: '透過驗證碼重設密碼，每日限 5 次。',
        },
        rules: {
            email1: '請輸入信箱',
            email2: '請輸入正確的信箱',
            verifyCode1: '請輸入邀請碼',
            pwd1: '請輸入密碼',
            confirmPwd1: '密碼不一致',
            password1: '請輸入確認密碼',
            verifyCode2: '請輸入驗證碼',
            verifyCode3: '請輸入正確的驗證碼',
            password2: '密碼不可包含空格',
            password3: '密碼長度不正確',
            email_not_registered: '信箱未註冊',
            login_failed: '登入失敗，請稍後再試',
            verifyCode_sent: '驗證碼已發送，請查收郵件',
            send_failed: '發送失敗',
            email_registered: '該信箱已註冊',
            register_success: '註冊成功',
            register_failed: '註冊失敗，請稍後再試',
            reset_password_success: '重設密碼成功',
            reset_password_failed: '重設密碼失敗，請稍後再試',
            login_popup_failed:
                '無法開啟 Google 登入視窗，請重試或檢查網路連線',
            login_popup_blocked: '登入彈窗被攔截，請允許瀏覽器彈窗',
            google_login_not_supported: '暫未支援 Google 登入',
        },
    },
    pl: {
        common_login_register: {
            login: 'Zaloguj się',
            register: 'Zarejestruj się',
            google: 'Zaloguj się przez Google',
            or: 'lub',
            email: 'E-mail',
            register_code: 'Wpisz kod zaproszenia',
        },
        login: {
            welcome: 'Witamy ponownie',
            title1: 'Zaloguj się, aby kontynuować',
            password: 'Hasło',
            detail1: 'Nie masz konta?',
            detail2: 'Zarejestruj się',
            register_code_required: 'Wpisz kod zaproszenia',
            register_code_invalid: 'Wpisz poprawny kod zaproszenia',
        },
        register: {
            createAccount: 'Utwórz konto',
            title2: 'Zarejestruj się i korzystaj z narzędzi marketingowych AI',
            getVerifyCode: 'Pobierz kod weryfikacyjny',
            verificationCode: 'Kod weryfikacyjny',
            sendCode: 'Wyślij kod',
            continue: 'Kontynuuj',
            detail1: 'Masz już konto?',
            detail2: 'Zaloguj się',
            newPassword: 'Hasło',
            confirm: 'Potwierdź hasło',
            confirmCreate: 'Utwórz konto',
            trash_can:
                'Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź spam.',
        },
        findPassword: {
            forgotPassword: 'Nie pamiętasz hasła',
            findBackPassword: 'Odzyskaj hasło',
            title: 'Zresetuj hasło za pomocą kodu weryfikacyjnego',
            email: 'E-mail',
            sendCode: 'Wyślij kod',
            resetPassword: 'Zresetuj hasło',
            detail1: 'Masz już konto?',
            detail2: 'Zaloguj się',
            newPassword: 'Hasło',
            confirm: 'Potwierdź hasło',
            tip: 'Reset hasła kodem weryfikacyjnym, limit 5 razy dziennie.',
        },
        rules: {
            email1: 'Wpisz adres e-mail',
            email2: 'Wpisz poprawny adres e-mail',
            verifyCode1: 'Wpisz kod zaproszenia',
            pwd1: 'Wpisz hasło',
            confirmPwd1: 'Hasła nie są zgodne',
            password1: 'Wpisz potwierdzenie hasła',
            verifyCode2: 'Wpisz kod weryfikacyjny',
            verifyCode3: 'Wpisz poprawny kod weryfikacyjny',
            password2: 'Hasło nie może zawierać spacji',
            password3: 'Nieprawidłowa długość hasła',
            email_not_registered: 'E-mail nie jest zarejestrowany',
            login_failed: 'Logowanie nie powiodło się, spróbuj później',
            verifyCode_sent: 'Kod weryfikacyjny został wysłany, sprawdź e-mail',
            send_failed: 'Wysyłka nieudana',
            email_registered: 'Ten e-mail jest już zarejestrowany',
            register_success: 'Rejestracja zakończona sukcesem',
            register_failed: 'Rejestracja nie powiodła się, spróbuj później',
            reset_password_success: 'Hasło zostało zresetowane',
            reset_password_failed:
                'Reset hasła nie powiódł się, spróbuj później',
            login_popup_failed:
                'Nie można otworzyć okna logowania Google, spróbuj ponownie lub sprawdź sieć',
            login_popup_blocked:
                'Okno logowania zostało zablokowane, zezwól na wyskakujące okna',
            google_login_not_supported:
                'Logowanie Google nie jest jeszcze obsługiwane',
        },
    },
    es: {
        common_login_register: {
            login: 'Iniciar Sesión',
            register: 'Registrarse',
            google: 'Iniciar sesión con Google',
            or: 'O',
            email: 'Correo Electrónico',
            register_code: 'Por favor ingrese el código de invitación',
        },
        login: {
            welcome: 'Bienvenido de nuevo',
            title1: 'Por favor inicie sesión para continuar',
            password: 'Contraseña',
            detail1: '¿No tienes una cuenta?',
            detail2: 'Regístrate ahora',
            register_code_required: 'Por favor ingrese el código de invitación',
            register_code_invalid:
                'Por favor ingrese el código de invitación correcto',
        },
        register: {
            createAccount: 'Crear Cuenta',
            title2: 'Comienza con herramientas de marketing impulsadas por IA',
            getVerifyCode: 'Obtener código de verificación',
            verificationCode: 'Código de verificación',
            sendCode: 'Enviar código',
            continue: 'Continuar',
            detail1: '¿Ya tienes una cuenta?',
            detail2: 'Inicia sesión ahora',
            newPassword: 'Contraseña',
            confirm: 'Confirmar contraseña',
            confirmCreate: 'Crear cuenta',
            trash_can:
                'Si no recibes el correo en tu bandeja de entrada, por favor revisa tu carpeta de spam.',
        },
        findPassword: {
            forgotPassword: 'Olvidé mi contraseña',
            findBackPassword: 'Recuperar contraseña',
            title: 'Restablecer contraseña mediante código de verificación',
            email: 'Correo Electrónico',
            sendCode: 'Enviar código',
            resetPassword: 'Restablecer contraseña',
            detail1: '¿Ya tienes una cuenta?',
            detail2: 'Inicia sesión ahora',
            newPassword: 'Contraseña',
            confirm: 'Confirmar contraseña',
            tip: 'Restablecer contraseña mediante código de verificación, limitado a 5 veces por día.',
        },
        rules: {
            email1: 'Por favor ingrese la dirección de correo electrónico',
            email2: 'Por favor ingrese una dirección de correo electrónico correcta',
            verifyCode1: 'Por favor ingrese el código de invitación',
            pwd1: 'Por favor ingrese la contraseña',
            confirmPwd1: 'Las contraseñas no coinciden',
            password1: 'Por favor ingrese la confirmación de contraseña',
            verifyCode2: 'Por favor ingrese el código de verificación',
            verifyCode3: 'Por favor ingrese el código de verificación correcto',
            password2: 'La contraseña no puede contener espacios',
            password3: 'La longitud de la contraseña es incorrecta',
            email_not_registered: 'Correo electrónico no registrado',
            login_failed:
                'Error al iniciar sesión, por favor intente más tarde',
            verifyCode_sent:
                'El código de verificación ha sido enviado, por favor revise su correo electrónico',
            send_failed: 'Error al enviar',
            email_registered: 'Este correo electrónico ya está registrado',
            register_success: 'Registro exitoso',
            register_failed:
                'Error al registrarse, por favor intente más tarde',
            reset_password_success: 'Contraseña restablecida exitosamente',
            reset_password_failed:
                'Error al restablecer la contraseña, por favor intente más tarde',
            login_popup_failed:
                'No se puede abrir la ventana de inicio de sesión de Google, por favor intente de nuevo o verifique la conexión de red',
            login_popup_blocked:
                'Ventana emergente de inicio de sesión bloqueada, por favor permita ventanas emergentes en su navegador',
            google_login_not_supported:
                'El inicio de sesión con Google aún no está soportado',
        },
    },
    fr: {
        common_login_register: {
            login: 'Connexion',
            register: "S'inscrire",
            google: 'Se connecter avec Google',
            or: 'OU',
            email: 'E-mail',
            register_code: "Veuillez entrer le code d'invitation",
        },
        login: {
            welcome: 'Bon retour',
            title1: 'Veuillez vous connecter pour continuer',
            password: 'Mot de passe',
            detail1: "Vous n'avez pas de compte ?",
            detail2: 'Inscrivez-vous maintenant',
            register_code_required: "Veuillez entrer le code d'invitation",
            register_code_invalid:
                "Veuillez entrer le code d'invitation correct",
        },
        register: {
            createAccount: 'Créer un Compte',
            title2: "Commencez avec des outils de marketing alimentés par l'IA",
            getVerifyCode: 'Obtenir le code de vérification',
            verificationCode: 'Code de vérification',
            sendCode: 'Envoyer le code',
            continue: 'Continuer',
            detail1: 'Vous avez déjà un compte ?',
            detail2: 'Connectez-vous maintenant',
            newPassword: 'Mot de passe',
            confirm: 'Confirmer le mot de passe',
            confirmCreate: 'Créer un compte',
            trash_can:
                "Si vous ne recevez pas l'e-mail dans votre boîte de réception, veuillez vérifier votre dossier de courrier indésirable.",
        },
        findPassword: {
            forgotPassword: 'Mot de passe oublié',
            findBackPassword: 'Récupérer le mot de passe',
            title: 'Réinitialiser le mot de passe via code de vérification',
            email: 'E-mail',
            sendCode: 'Envoyer le code',
            resetPassword: 'Réinitialiser le mot de passe',
            detail1: 'Vous avez déjà un compte ?',
            detail2: 'Connectez-vous maintenant',
            newPassword: 'Mot de passe',
            confirm: 'Confirmer le mot de passe',
            tip: 'Réinitialiser le mot de passe via code de vérification, limité à 5 fois par jour.',
        },
        rules: {
            email1: "Veuillez entrer l'adresse e-mail",
            email2: 'Veuillez entrer une adresse e-mail correcte',
            verifyCode1: "Veuillez entrer le code d'invitation",
            pwd1: 'Veuillez entrer le mot de passe',
            confirmPwd1: 'Les mots de passe ne correspondent pas',
            password1: 'Veuillez entrer la confirmation du mot de passe',
            verifyCode2: 'Veuillez entrer le code de vérification',
            verifyCode3: 'Veuillez entrer le code de vérification correct',
            password2: "Le mot de passe ne peut pas contenir d'espaces",
            password3: 'La longueur du mot de passe est incorrecte',
            email_not_registered: 'E-mail non enregistré',
            login_failed: 'Échec de la connexion, veuillez réessayer plus tard',
            verifyCode_sent:
                'Le code de vérification a été envoyé, veuillez vérifier votre e-mail',
            send_failed: "Échec de l'envoi",
            email_registered: 'Cet e-mail est déjà enregistré',
            register_success: 'Inscription réussie',
            register_failed:
                "Échec de l'inscription, veuillez réessayer plus tard",
            reset_password_success: 'Réinitialisation du mot de passe réussie',
            reset_password_failed:
                'Échec de la réinitialisation du mot de passe, veuillez réessayer plus tard',
            login_popup_failed:
                "Impossible d'ouvrir la fenêtre de connexion Google, veuillez réessayer ou vérifier la connexion réseau",
            login_popup_blocked:
                'Fenêtre contextuelle de connexion bloquée, veuillez autoriser les fenêtres contextuelles dans votre navigateur',
            google_login_not_supported:
                "La connexion Google n'est pas encore prise en charge",
        },
    },
    de: {
        common_login_register: {
            login: 'Anmelden',
            register: 'Registrieren',
            google: 'Mit Google anmelden',
            or: 'ODER',
            email: 'E-Mail',
            register_code: 'Bitte geben Sie den Einladungscode ein',
        },
        login: {
            welcome: 'Willkommen zurück',
            title1: 'Bitte melden Sie sich an, um fortzufahren',
            password: 'Passwort',
            detail1: 'Haben Sie kein Konto?',
            detail2: 'Jetzt registrieren',
            register_code_required: 'Bitte geben Sie den Einladungscode ein',
            register_code_invalid:
                'Bitte geben Sie den korrekten Einladungscode ein',
        },
        register: {
            createAccount: 'Konto Erstellen',
            title2: 'Beginnen Sie mit KI-gestützten Marketing-Tools',
            getVerifyCode: 'Bestätigungscode abrufen',
            verificationCode: 'Bestätigungscode',
            sendCode: 'Code senden',
            continue: 'Weiter',
            detail1: 'Haben Sie bereits ein Konto?',
            detail2: 'Jetzt anmelden',
            newPassword: 'Passwort',
            confirm: 'Passwort bestätigen',
            confirmCreate: 'Konto erstellen',
            trash_can:
                'Wenn Sie die E-Mail nicht in Ihrem Posteingang erhalten, überprüfen Sie bitte Ihren Spam-Ordner.',
        },
        findPassword: {
            forgotPassword: 'Passwort vergessen',
            findBackPassword: 'Passwort wiederherstellen',
            title: 'Passwort per Bestätigungscode zurücksetzen',
            email: 'E-Mail',
            sendCode: 'Code senden',
            resetPassword: 'Passwort zurücksetzen',
            detail1: 'Haben Sie bereits ein Konto?',
            detail2: 'Jetzt anmelden',
            newPassword: 'Passwort',
            confirm: 'Passwort bestätigen',
            tip: 'Passwort per Bestätigungscode zurücksetzen, begrenzt auf 5 Mal pro Tag.',
        },
        rules: {
            email1: 'Bitte geben Sie die E-Mail-Adresse ein',
            email2: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            verifyCode1: 'Bitte geben Sie den Einladungscode ein',
            pwd1: 'Bitte geben Sie das Passwort ein',
            confirmPwd1: 'Die Passwörter stimmen nicht überein',
            password1: 'Bitte geben Sie die Passwortbestätigung ein',
            verifyCode2: 'Bitte geben Sie den Bestätigungscode ein',
            verifyCode3: 'Bitte geben Sie den korrekten Bestätigungscode ein',
            password2: 'Das Passwort darf keine Leerzeichen enthalten',
            password3: 'Die Passwortlänge ist falsch',
            email_not_registered: 'E-Mail nicht registriert',
            login_failed:
                'Anmeldung fehlgeschlagen, bitte versuchen Sie es später erneut',
            verifyCode_sent:
                'Bestätigungscode wurde gesendet, bitte überprüfen Sie Ihre E-Mail',
            send_failed: 'Senden fehlgeschlagen',
            email_registered: 'Diese E-Mail ist bereits registriert',
            register_success: 'Registrierung erfolgreich',
            register_failed:
                'Registrierung fehlgeschlagen, bitte versuchen Sie es später erneut',
            reset_password_success: 'Passwort erfolgreich zurückgesetzt',
            reset_password_failed:
                'Passwort zurücksetzen fehlgeschlagen, bitte versuchen Sie es später erneut',
            login_popup_failed:
                'Google-Anmeldefenster kann nicht geöffnet werden, bitte versuchen Sie es erneut oder überprüfen Sie die Netzwerkverbindung',
            login_popup_blocked:
                'Anmelde-Popup blockiert, bitte erlauben Sie Pop-ups in Ihrem Browser',
            google_login_not_supported:
                'Google-Anmeldung wird noch nicht unterstützt',
        },
    },
    ru: {
        common_login_register: {
            login: 'Войти',
            register: 'Регистрация',
            google: 'Войти через Google',
            or: 'ИЛИ',
            email: 'Электронная почта',
            register_code: 'Пожалуйста, введите код приглашения',
        },
        login: {
            welcome: 'С возвращением',
            title1: 'Пожалуйста, войдите, чтобы продолжить',
            password: 'Пароль',
            detail1: 'Нет аккаунта?',
            detail2: 'Зарегистрироваться сейчас',
            register_code_required: 'Пожалуйста, введите код приглашения',
            register_code_invalid:
                'Пожалуйста, введите правильный код приглашения',
        },
        register: {
            createAccount: 'Создать Аккаунт',
            title2: 'Начните работу с инструментами маркетинга на основе ИИ',
            getVerifyCode: 'Получить код подтверждения',
            verificationCode: 'Код подтверждения',
            sendCode: 'Отправить код',
            continue: 'Продолжить',
            detail1: 'Уже есть аккаунт?',
            detail2: 'Войти сейчас',
            newPassword: 'Пароль',
            confirm: 'Подтвердить пароль',
            confirmCreate: 'Создать аккаунт',
            trash_can:
                'Если вы не получили письмо в папке "Входящие", пожалуйста, проверьте папку "Спам".',
        },
        findPassword: {
            forgotPassword: 'Забыли пароль',
            findBackPassword: 'Восстановить пароль',
            title: 'Сброс пароля через код подтверждения',
            email: 'Электронная почта',
            sendCode: 'Отправить код',
            resetPassword: 'Сбросить пароль',
            detail1: 'Уже есть аккаунт?',
            detail2: 'Войти сейчас',
            newPassword: 'Пароль',
            confirm: 'Подтвердить пароль',
            tip: 'Сброс пароля через код подтверждения, ограничено 5 раз в день.',
        },
        rules: {
            email1: 'Пожалуйста, введите адрес электронной почты',
            email2: 'Пожалуйста, введите правильный адрес электронной почты',
            verifyCode1: 'Пожалуйста, введите код приглашения',
            pwd1: 'Пожалуйста, введите пароль',
            confirmPwd1: 'Пароли не совпадают',
            password1: 'Пожалуйста, введите подтверждение пароля',
            verifyCode2: 'Пожалуйста, введите код подтверждения',
            verifyCode3: 'Пожалуйста, введите правильный код подтверждения',
            password2: 'Пароль не может содержать пробелы',
            password3: 'Длина пароля неверна',
            email_not_registered: 'Электронная почта не зарегистрирована',
            login_failed: 'Ошибка входа, пожалуйста, попробуйте позже',
            verifyCode_sent:
                'Код подтверждения отправлен, пожалуйста, проверьте вашу электронную почту',
            send_failed: 'Ошибка отправки',
            email_registered: 'Эта электронная почта уже зарегистрирована',
            register_success: 'Регистрация успешна',
            register_failed: 'Ошибка регистрации, пожалуйста, попробуйте позже',
            reset_password_success: 'Пароль успешно сброшен',
            reset_password_failed:
                'Ошибка сброса пароля, пожалуйста, попробуйте позже',
            login_popup_failed:
                'Не удалось открыть окно входа Google, пожалуйста, попробуйте снова или проверьте сетевое подключение',
            login_popup_blocked:
                'Всплывающее окно входа заблокировано, пожалуйста, разрешите всплывающие окна в вашем браузере',
            google_login_not_supported:
                'Вход через Google пока не поддерживается',
        },
    },
    pt: {
        common_login_register: {
            login: 'Entrar',
            register: 'Registrar',
            google: 'Entrar com Google',
            or: 'OU',
            email: 'E-mail',
            register_code: 'Por favor, insira o código de convite',
        },
        login: {
            welcome: 'Bem-vindo de volta',
            title1: 'Por favor, faça login para continuar',
            password: 'Senha',
            detail1: 'Não tem uma conta?',
            detail2: 'Cadastre-se agora',
            register_code_required: 'Por favor, insira o código de convite',
            register_code_invalid:
                'Por favor, insira o código de convite correto',
        },
        register: {
            createAccount: 'Criar Conta',
            title2: 'Comece com ferramentas de marketing alimentadas por IA',
            getVerifyCode: 'Obter código de verificação',
            verificationCode: 'Código de verificação',
            sendCode: 'Enviar código',
            continue: 'Continuar',
            detail1: 'Já tem uma conta?',
            detail2: 'Entrar agora',
            newPassword: 'Senha',
            confirm: 'Confirmar senha',
            confirmCreate: 'Criar conta',
            trash_can:
                'Se você não receber o e-mail na sua caixa de entrada, verifique sua pasta de spam.',
        },
        findPassword: {
            forgotPassword: 'Esqueci a senha',
            findBackPassword: 'Recuperar senha',
            title: 'Redefinir senha através do código de verificação',
            email: 'E-mail',
            sendCode: 'Enviar código',
            resetPassword: 'Redefinir senha',
            detail1: 'Já tem uma conta?',
            detail2: 'Entrar agora',
            newPassword: 'Senha',
            confirm: 'Confirmar senha',
            tip: 'Redefinir senha através do código de verificação, limitado a 5 vezes por dia.',
        },
        rules: {
            email1: 'Por favor, insira o endereço de e-mail',
            email2: 'Por favor, insira um endereço de e-mail correto',
            verifyCode1: 'Por favor, insira o código de convite',
            pwd1: 'Por favor, insira a senha',
            confirmPwd1: 'As senhas não coincidem',
            password1: 'Por favor, insira a confirmação de senha',
            verifyCode2: 'Por favor, insira o código de verificação',
            verifyCode3: 'Por favor, insira o código de verificação correto',
            password2: 'A senha não pode conter espaços',
            password3: 'O comprimento da senha está incorreto',
            email_not_registered: 'E-mail não registrado',
            login_failed:
                'Falha no login, por favor tente novamente mais tarde',
            verifyCode_sent:
                'Código de verificação foi enviado, por favor verifique seu e-mail',
            send_failed: 'Falha no envio',
            email_registered: 'Este e-mail já está registrado',
            register_success: 'Registro bem-sucedido',
            register_failed:
                'Falha no registro, por favor tente novamente mais tarde',
            reset_password_success: 'Senha redefinida com sucesso',
            reset_password_failed:
                'Falha ao redefinir senha, por favor tente novamente mais tarde',
            login_popup_failed:
                'Não é possível abrir a janela de login do Google, por favor tente novamente ou verifique a conexão de rede',
            login_popup_blocked:
                'Popup de login bloqueado, por favor permita pop-ups no seu navegador',
            google_login_not_supported: 'Login do Google ainda não é suportado',
        },
    },
    it: {
        common_login_register: {
            login: 'Accedi',
            register: 'Registrati',
            google: 'Accedi con Google',
            or: 'O',
            email: 'E-mail',
            register_code: 'Inserisci il codice di invito',
        },
        login: {
            welcome: 'Bentornato',
            title1: 'Accedi per continuare',
            password: 'Password',
            detail1: 'Non hai un account?',
            detail2: 'Registrati ora',
            register_code_required: 'Inserisci il codice di invito',
            register_code_invalid: 'Inserisci il codice di invito corretto',
        },
        register: {
            createAccount: 'Crea Account',
            title2: "Inizia con strumenti di marketing alimentati dall'IA",
            getVerifyCode: 'Ottieni codice di verifica',
            verificationCode: 'Codice di verifica',
            sendCode: 'Invia codice',
            continue: 'Continua',
            detail1: 'Hai già un account?',
            detail2: 'Accedi ora',
            newPassword: 'Password',
            confirm: 'Conferma password',
            confirmCreate: 'Crea account',
            trash_can:
                "Se non ricevi l'e-mail nella tua casella di posta, controlla la cartella spam.",
        },
        findPassword: {
            forgotPassword: 'Password dimenticata',
            findBackPassword: 'Recupera password',
            title: 'Reimposta password tramite codice di verifica',
            email: 'E-mail',
            sendCode: 'Invia codice',
            resetPassword: 'Reimposta password',
            detail1: 'Hai già un account?',
            detail2: 'Accedi ora',
            newPassword: 'Password',
            confirm: 'Conferma password',
            tip: 'Reimposta password tramite codice di verifica, limitato a 5 volte al giorno.',
        },
        rules: {
            email1: "Inserisci l'indirizzo email",
            email2: 'Inserisci un indirizzo email corretto',
            verifyCode1: 'Inserisci il codice di invito',
            pwd1: 'Inserisci la password',
            confirmPwd1: 'Le password non corrispondono',
            password1: 'Inserisci la conferma password',
            verifyCode2: 'Inserisci il codice di verifica',
            verifyCode3: 'Inserisci il codice di verifica corretto',
            password2: 'La password non può contenere spazi',
            password3: 'La lunghezza della password non è corretta',
            email_not_registered: 'Email non registrata',
            login_failed: 'Accesso fallito, riprova più tardi',
            verifyCode_sent:
                'Codice di verifica inviato, controlla la tua email',
            send_failed: 'Invio fallito',
            email_registered: 'Questa email è già registrata',
            register_success: 'Registrazione riuscita',
            register_failed: 'Registrazione fallita, riprova più tardi',
            reset_password_success: 'Password reimpostata con successo',
            reset_password_failed:
                'Reimpostazione password fallita, riprova più tardi',
            login_popup_failed:
                'Impossibile aprire la finestra di accesso Google, riprova o verifica la connessione di rete',
            login_popup_blocked:
                'Popup di accesso bloccato, consenti i popup nel tuo browser',
            google_login_not_supported: 'Accesso Google non ancora supportato',
        },
    },
    ar: {
        common_login_register: {
            login: 'تسجيل الدخول',
            register: 'التسجيل',
            google: 'تسجيل الدخول باستخدام Google',
            or: 'أو',
            email: 'البريد الإلكتروني',
            register_code: 'يرجى إدخال رمز الدعوة',
        },
        login: {
            welcome: 'مرحباً بعودتك',
            title1: 'يرجى تسجيل الدخول للمتابعة',
            password: 'كلمة المرور',
            detail1: 'ليس لديك حساب؟',
            detail2: 'سجل الآن',
            register_code_required: 'يرجى إدخال رمز الدعوة',
            register_code_invalid: 'يرجى إدخال رمز الدعوة الصحيح',
        },
        register: {
            createAccount: 'إنشاء حساب',
            title2: 'ابدأ باستخدام أدوات التسويق المدعومة بالذكاء الاصطناعي',
            getVerifyCode: 'الحصول على رمز التحقق',
            verificationCode: 'رمز التحقق',
            sendCode: 'إرسال الرمز',
            continue: 'متابعة',
            detail1: 'لديك حساب بالفعل؟',
            detail2: 'تسجيل الدخول الآن',
            newPassword: 'كلمة المرور',
            confirm: 'تأكيد كلمة المرور',
            confirmCreate: 'إنشاء حساب',
            trash_can:
                'إذا لم تستلم البريد الإلكتروني في صندوق الوارد، يرجى التحقق من مجلد الرسائل غير المرغوب فيها.',
        },
        findPassword: {
            forgotPassword: 'نسيت كلمة المرور',
            findBackPassword: 'استعادة كلمة المرور',
            title: 'إعادة تعيين كلمة المرور عبر رمز التحقق',
            email: 'البريد الإلكتروني',
            sendCode: 'إرسال الرمز',
            resetPassword: 'إعادة تعيين كلمة المرور',
            detail1: 'لديك حساب بالفعل؟',
            detail2: 'تسجيل الدخول الآن',
            newPassword: 'كلمة المرور',
            confirm: 'تأكيد كلمة المرور',
            tip: 'إعادة تعيين كلمة المرور عبر رمز التحقق، محدود بـ 5 مرات في اليوم.',
        },
        rules: {
            email1: 'يرجى إدخال عنوان البريد الإلكتروني',
            email2: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
            verifyCode1: 'يرجى إدخال رمز الدعوة',
            pwd1: 'يرجى إدخال كلمة المرور',
            confirmPwd1: 'كلمات المرور غير متطابقة',
            password1: 'يرجى إدخال تأكيد كلمة المرور',
            verifyCode2: 'يرجى إدخال رمز التحقق',
            verifyCode3: 'يرجى إدخال رمز التحقق الصحيح',
            password2: 'لا يمكن أن تحتوي كلمة المرور على مسافات',
            password3: 'طول كلمة المرور غير صحيح',
            email_not_registered: 'البريد الإلكتروني غير مسجل',
            login_failed: 'فشل تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقاً',
            verifyCode_sent:
                'تم إرسال رمز التحقق، يرجى التحقق من بريدك الإلكتروني',
            send_failed: 'فشل الإرسال',
            email_registered: 'هذا البريد الإلكتروني مسجل بالفعل',
            register_success: 'تم التسجيل بنجاح',
            register_failed: 'فشل التسجيل، يرجى المحاولة مرة أخرى لاحقاً',
            reset_password_success: 'تم إعادة تعيين كلمة المرور بنجاح',
            reset_password_failed:
                'فشل إعادة تعيين كلمة المرور، يرجى المحاولة مرة أخرى لاحقاً',
            login_popup_failed:
                'لا يمكن فتح نافذة تسجيل الدخول من Google، يرجى المحاولة مرة أخرى أو التحقق من اتصال الشبكة',
            login_popup_blocked:
                'تم حظر نافذة تسجيل الدخول المنبثقة، يرجى السماح بالنوافذ المنبثقة في متصفحك',
            google_login_not_supported: 'تسجيل الدخول عبر Google غير مدعوم بعد',
        },
    },
    // 泰语
    th: {
        common_login_register: {
            login: 'เข้าสู่ระบบ',
            register: 'ลงทะเบียน',
            google: 'เข้าสู่ระบบด้วย Google',
            or: 'หรือ',
            email: 'อีเมล',
            register_code: 'กรุณาใส่รหัสเชิญ',
        },
        login: {
            welcome: 'ยินดีต้อนรับกลับ',
            title1: 'กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ',
            password: 'รหัสผ่าน',
            detail1: 'ยังไม่มีบัญชี?',
            detail2: 'ลงทะเบียนเลย',
            register_code_required: 'กรุณาใส่รหัสเชิญ',
            register_code_invalid: 'กรุณาใส่รหัสเชิญที่ถูกต้อง',
        },
        register: {
            createAccount: 'สร้างบัญชี',
            title2: 'เริ่มต้นใช้งานเครื่องมือการตลาด AI',
            getVerifyCode: 'รับรหัสยืนยัน',
            verificationCode: 'รหัสยืนยัน',
            sendCode: 'ส่งรหัส',
            continue: 'ดำเนินการต่อ',
            detail1: 'มีบัญชีอยู่แล้ว?',
            detail2: 'เข้าสู่ระบบเลย',
            newPassword: 'รหัสผ่าน',
            confirm: 'ยืนยันรหัสผ่าน',
            confirmCreate: 'สร้างบัญชี',
            trash_can:
                'หากไม่ได้รับอีเมลในกล่องจดหมาย กรุณาตรวจสอบโฟลเดอร์สแปม',
        },
        findPassword: {
            forgotPassword: 'ลืมรหัสผ่าน',
            findBackPassword: 'กู้คืนรหัสผ่าน',
            title: 'รีเซ็ตรหัสผ่านด้วยรหัสยืนยัน',
            email: 'อีเมล',
            sendCode: 'ส่งรหัส',
            resetPassword: 'รีเซ็ตรหัสผ่าน',
            detail1: 'มีบัญชีอยู่แล้ว?',
            detail2: 'เข้าสู่ระบบเลย',
            newPassword: 'รหัสผ่าน',
            confirm: 'ยืนยันรหัสผ่าน',
            tip: 'รีเซ็ตรหัสผ่านด้วยรหัสยืนยัน จำกัด 5 ครั้งต่อวัน',
        },
        rules: {
            email1: 'กรุณาใส่ที่อยู่อีเมล',
            email2: 'กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง',
            verifyCode1: 'กรุณาใส่รหัสเชิญ',
            pwd1: 'กรุณาใส่รหัสผ่าน',
            confirmPwd1: 'รหัสผ่านไม่ตรงกัน',
            password1: 'กรุณาใส่การยืนยันรหัสผ่าน',
            verifyCode2: 'กรุณาใส่รหัสยืนยัน',
            verifyCode3: 'กรุณาใส่รหัสยืนยันที่ถูกต้อง',
            password2: 'รหัสผ่านไม่สามารถมีช่องว่างได้',
            password3: 'ความยาวรหัสผ่านไม่ถูกต้อง',
            email_not_registered: 'อีเมลไม่ได้ลงทะเบียน',
            login_failed: 'เข้าสู่ระบบล้มเหลว กรุณาลองใหม่ภายหลัง',
            verifyCode_sent: 'ส่งรหัสยืนยันแล้ว กรุณาตรวจสอบอีเมลของคุณ',
            send_failed: 'ส่งล้มเหลว',
            email_registered: 'อีเมลนี้ลงทะเบียนแล้ว',
            register_success: 'ลงทะเบียนสำเร็จ',
            register_failed: 'ลงทะเบียนล้มเหลว กรุณาลองใหม่ภายหลัง',
            reset_password_success: 'รีเซ็ตรหัสผ่านสำเร็จ',
            reset_password_failed: 'รีเซ็ตรหัสผ่านล้มเหลว กรุณาลองใหม่ภายหลัง',
            login_popup_failed:
                'ไม่สามารถเปิดหน้าต่างเข้าสู่ระบบ Google ได้ กรุณาลองใหม่หรือตรวจสอบการเชื่อมต่อเครือข่าย',
            login_popup_blocked:
                'ป๊อปอัปเข้าสู่ระบบถูกบล็อก กรุณาอนุญาตป๊อปอัปในเบราว์เซอร์ของคุณ',
            google_login_not_supported: 'ยังไม่รองรับการเข้าสู่ระบบด้วย Google',
        },
    },
    // 丹麦语
    da: {
        common_login_register: {
            login: 'Log ind',
            register: 'Registrer',
            google: 'Log ind med Google',
            or: 'ELLER',
            email: 'E-mail',
            register_code: 'Indtast venligst invitationskode',
        },
        login: {
            welcome: 'Velkommen tilbage',
            title1: 'Log venligst ind for at fortsætte',
            password: 'Adgangskode',
            detail1: 'Har du ikke en konto?',
            detail2: 'Tilmeld dig nu',
            register_code_required: 'Indtast venligst invitationskode',
            register_code_invalid: 'Indtast venligst korrekt invitationskode',
        },
        register: {
            createAccount: 'Opret konto',
            title2: 'Kom i gang med AI-drevne marketingværktøjer',
            getVerifyCode: 'Få bekræftelseskode',
            verificationCode: 'Bekræftelseskode',
            sendCode: 'Send kode',
            continue: 'Fortsæt',
            detail1: 'Har du allerede en konto?',
            detail2: 'Log ind nu',
            newPassword: 'Adgangskode',
            confirm: 'Bekræft adgangskode',
            confirmCreate: 'Opret konto',
            trash_can:
                'Hvis du ikke modtager e-mailen i din indbakke, tjek venligst din spam-mappe.',
        },
        findPassword: {
            forgotPassword: 'Glemt adgangskode',
            findBackPassword: 'Gendan adgangskode',
            title: 'Nulstil adgangskode via bekræftelseskode',
            email: 'E-mail',
            sendCode: 'Send kode',
            resetPassword: 'Nulstil adgangskode',
            detail1: 'Har du allerede en konto?',
            detail2: 'Log ind nu',
            newPassword: 'Adgangskode',
            confirm: 'Bekræft adgangskode',
            tip: 'Nulstil adgangskode via bekræftelseskode, begrænset til 5 gange om dagen.',
        },
        rules: {
            email1: 'Indtast venligst e-mailadresse',
            email2: 'Indtast venligst korrekt e-mailadresse',
            verifyCode1: 'Indtast venligst invitationskode',
            pwd1: 'Indtast venligst adgangskode',
            confirmPwd1: 'Adgangskoderne matcher ikke',
            password1: 'Indtast venligst bekræftelse af adgangskode',
            verifyCode2: 'Indtast venligst bekræftelseskode',
            verifyCode3: 'Indtast venligst korrekt bekræftelseskode',
            password2: 'Adgangskode kan ikke indeholde mellemrum',
            password3: 'Adgangskodets længde er forkert',
            email_not_registered: 'E-mail ikke registreret',
            login_failed: 'Login mislykkedes, prøv igen senere',
            verifyCode_sent:
                'Bekræftelseskode er sendt, tjek venligst din e-mail',
            send_failed: 'Afsendelse mislykkedes',
            email_registered: 'Denne e-mail er allerede registreret',
            register_success: 'Registrering lykkedes',
            register_failed: 'Registrering mislykkedes, prøv igen senere',
            reset_password_success: 'Adgangskode nulstillet',
            reset_password_failed:
                'Nulstilling af adgangskode mislykkedes, prøv igen senere',
            login_popup_failed:
                'Kan ikke åbne Google login-vindue, prøv igen eller tjek netværksforbindelse',
            login_popup_blocked:
                'Login popup blokeret, tillad venligst popups i din browser',
            google_login_not_supported: 'Google login understøttes ikke endnu',
        },
    },
    // 挪威语
    no: {
        common_login_register: {
            login: 'Logg inn',
            register: 'Registrer',
            google: 'Logg inn med Google',
            or: 'ELLER',
            email: 'E-post',
            register_code: 'Vennligst skriv inn invitasjonskode',
        },
        login: {
            welcome: 'Velkommen tilbake',
            title1: 'Vennligst logg inn for å fortsette',
            password: 'Passord',
            detail1: 'Har du ikke en konto?',
            detail2: 'Registrer deg nå',
            register_code_required: 'Vennligst skriv inn invitasjonskode',
            register_code_invalid: 'Vennligst skriv inn riktig invitasjonskode',
        },
        register: {
            createAccount: 'Opprett konto',
            title2: 'Kom i gang med AI-drevne markedsføringsverktøy',
            getVerifyCode: 'Få bekreftelseskode',
            verificationCode: 'Bekreftelseskode',
            sendCode: 'Send kode',
            continue: 'Fortsett',
            detail1: 'Har du allerede en konto?',
            detail2: 'Logg inn nå',
            newPassword: 'Passord',
            confirm: 'Bekreft passord',
            confirmCreate: 'Opprett konto',
            trash_can:
                'Hvis du ikke mottar e-posten i innboksen, sjekk spam-mappen.',
        },
        findPassword: {
            forgotPassword: 'Glemt passord',
            findBackPassword: 'Gjenopprett passord',
            title: 'Tilbakestill passord via bekreftelseskode',
            email: 'E-post',
            sendCode: 'Send kode',
            resetPassword: 'Tilbakestill passord',
            detail1: 'Har du allerede en konto?',
            detail2: 'Logg inn nå',
            newPassword: 'Passord',
            confirm: 'Bekreft passord',
            tip: 'Tilbakestill passord via bekreftelseskode, begrenset til 5 ganger per dag.',
        },
        rules: {
            email1: 'Vennligst skriv inn e-postadresse',
            email2: 'Vennligst skriv inn riktig e-postadresse',
            verifyCode1: 'Vennligst skriv inn invitasjonskode',
            pwd1: 'Vennligst skriv inn passord',
            confirmPwd1: 'Passordene samsvarer ikke',
            password1: 'Vennligst skriv inn passordbekreftelse',
            verifyCode2: 'Vennligst skriv inn bekreftelseskode',
            verifyCode3: 'Vennligst skriv inn riktig bekreftelseskode',
            password2: 'Passord kan ikke inneholde mellomrom',
            password3: 'Passordlengden er feil',
            email_not_registered: 'E-post ikke registrert',
            login_failed: 'Innlogging mislyktes, prøv igjen senere',
            verifyCode_sent: 'Bekreftelseskode er sendt, sjekk e-posten din',
            send_failed: 'Sending mislyktes',
            email_registered: 'Denne e-posten er allerede registrert',
            register_success: 'Registrering vellykket',
            register_failed: 'Registrering mislyktes, prøv igjen senere',
            reset_password_success: 'Passord tilbakestilt',
            reset_password_failed:
                'Tilbakestilling av passord mislyktes, prøv igjen senere',
            login_popup_failed:
                'Kan ikke åpne Google innloggingsvindu, prøv igjen eller sjekk nettverkstilkobling',
            login_popup_blocked:
                'Innloggingspopup blokkert, vennligst tillat popups i nettleseren',
            google_login_not_supported: 'Google innlogging støttes ikke ennå',
        },
    },
    // 荷兰语
    nl: {
        common_login_register: {
            login: 'Inloggen',
            register: 'Registreren',
            google: 'Inloggen met Google',
            or: 'OF',
            email: 'E-mail',
            register_code: 'Voer de uitnodigingscode in',
        },
        login: {
            welcome: 'Welkom terug',
            title1: 'Log in om door te gaan',
            password: 'Wachtwoord',
            detail1: 'Geen account?',
            detail2: 'Nu registreren',
            register_code_required: 'Voer de uitnodigingscode in',
            register_code_invalid: 'Voer de juiste uitnodigingscode in',
        },
        register: {
            createAccount: 'Account aanmaken',
            title2: 'Begin met AI-aangedreven marketingtools',
            getVerifyCode: 'Verificatiecode ophalen',
            verificationCode: 'Verificatiecode',
            sendCode: 'Code verzenden',
            continue: 'Doorgaan',
            detail1: 'Heeft u al een account?',
            detail2: 'Nu inloggen',
            newPassword: 'Wachtwoord',
            confirm: 'Wachtwoord bevestigen',
            confirmCreate: 'Account aanmaken',
            trash_can:
                'Als u de e-mail niet in uw inbox ontvangt, controleer dan uw spammap.',
        },
        findPassword: {
            forgotPassword: 'Wachtwoord vergeten',
            findBackPassword: 'Wachtwoord herstellen',
            title: 'Wachtwoord resetten via verificatiecode',
            email: 'E-mail',
            sendCode: 'Code verzenden',
            resetPassword: 'Wachtwoord resetten',
            detail1: 'Heeft u al een account?',
            detail2: 'Nu inloggen',
            newPassword: 'Wachtwoord',
            confirm: 'Wachtwoord bevestigen',
            tip: 'Wachtwoord resetten via verificatiecode, beperkt tot 5 keer per dag.',
        },
        rules: {
            email1: 'Voer het e-mailadres in',
            email2: 'Voer een geldig e-mailadres in',
            verifyCode1: 'Voer de uitnodigingscode in',
            pwd1: 'Voer het wachtwoord in',
            confirmPwd1: 'Wachtwoorden komen niet overeen',
            password1: 'Voer de wachtwoordbevestiging in',
            verifyCode2: 'Voer de verificatiecode in',
            verifyCode3: 'Voer de juiste verificatiecode in',
            password2: 'Wachtwoord mag geen spaties bevatten',
            password3: 'Wachtwoordlengte is onjuist',
            email_not_registered: 'E-mail niet geregistreerd',
            login_failed: 'Inloggen mislukt, probeer het later opnieuw',
            verifyCode_sent:
                'Verificatiecode is verzonden, controleer uw e-mail',
            send_failed: 'Verzenden mislukt',
            email_registered: 'Deze e-mail is al geregistreerd',
            register_success: 'Registratie geslaagd',
            register_failed: 'Registratie mislukt, probeer het later opnieuw',
            reset_password_success: 'Wachtwoord succesvol gereset',
            reset_password_failed:
                'Wachtwoord resetten mislukt, probeer het later opnieuw',
            login_popup_failed:
                'Kan Google-inlogvenster niet openen, probeer opnieuw of controleer de netwerkverbinding',
            login_popup_blocked:
                'Inlogpopup geblokkeerd, sta popups toe in uw browser',
            google_login_not_supported:
                'Google-inloggen wordt nog niet ondersteund',
        },
    },
    // 印尼语
    id: {
        common_login_register: {
            login: 'Masuk',
            register: 'Daftar',
            google: 'Masuk dengan Google',
            or: 'ATAU',
            email: 'Email',
            register_code: 'Silakan masukkan kode undangan',
        },
        login: {
            welcome: 'Selamat datang kembali',
            title1: 'Silakan masuk untuk melanjutkan',
            password: 'Kata sandi',
            detail1: 'Belum punya akun?',
            detail2: 'Daftar sekarang',
            register_code_required: 'Silakan masukkan kode undangan',
            register_code_invalid: 'Silakan masukkan kode undangan yang benar',
        },
        register: {
            createAccount: 'Buat Akun',
            title2: 'Mulai dengan alat pemasaran bertenaga AI',
            getVerifyCode: 'Dapatkan kode verifikasi',
            verificationCode: 'Kode verifikasi',
            sendCode: 'Kirim kode',
            continue: 'Lanjutkan',
            detail1: 'Sudah punya akun?',
            detail2: 'Masuk sekarang',
            newPassword: 'Kata sandi',
            confirm: 'Konfirmasi kata sandi',
            confirmCreate: 'Buat akun',
            trash_can:
                'Jika Anda tidak menerima email di kotak masuk, silakan periksa folder spam.',
        },
        findPassword: {
            forgotPassword: 'Lupa kata sandi',
            findBackPassword: 'Pulihkan kata sandi',
            title: 'Reset kata sandi melalui kode verifikasi',
            email: 'Email',
            sendCode: 'Kirim kode',
            resetPassword: 'Reset kata sandi',
            detail1: 'Sudah punya akun?',
            detail2: 'Masuk sekarang',
            newPassword: 'Kata sandi',
            confirm: 'Konfirmasi kata sandi',
            tip: 'Reset kata sandi melalui kode verifikasi, dibatasi 5 kali per hari.',
        },
        rules: {
            email1: 'Silakan masukkan alamat email',
            email2: 'Silakan masukkan alamat email yang benar',
            verifyCode1: 'Silakan masukkan kode undangan',
            pwd1: 'Silakan masukkan kata sandi',
            confirmPwd1: 'Kata sandi tidak cocok',
            password1: 'Silakan masukkan konfirmasi kata sandi',
            verifyCode2: 'Silakan masukkan kode verifikasi',
            verifyCode3: 'Silakan masukkan kode verifikasi yang benar',
            password2: 'Kata sandi tidak boleh mengandung spasi',
            password3: 'Panjang kata sandi salah',
            email_not_registered: 'Email tidak terdaftar',
            login_failed: 'Login gagal, silakan coba lagi nanti',
            verifyCode_sent:
                'Kode verifikasi telah dikirim, silakan periksa email Anda',
            send_failed: 'Pengiriman gagal',
            email_registered: 'Email ini sudah terdaftar',
            register_success: 'Pendaftaran berhasil',
            register_failed: 'Pendaftaran gagal, silakan coba lagi nanti',
            reset_password_success: 'Kata sandi berhasil direset',
            reset_password_failed:
                'Reset kata sandi gagal, silakan coba lagi nanti',
            login_popup_failed:
                'Tidak dapat membuka jendela login Google, silakan coba lagi atau periksa koneksi jaringan',
            login_popup_blocked:
                'Popup login diblokir, silakan izinkan popup di browser Anda',
            google_login_not_supported: 'Login Google belum didukung',
        },
    },
    // 土耳其语
    tr: {
        common_login_register: {
            login: 'Giriş Yap',
            register: 'Kayıt Ol',
            google: 'Google ile Giriş Yap',
            or: 'VEYA',
            email: 'E-posta',
            register_code: 'Lütfen davet kodunu girin',
        },
        login: {
            welcome: 'Tekrar hoş geldiniz',
            title1: 'Devam etmek için lütfen giriş yapın',
            password: 'Şifre',
            detail1: 'Hesabınız yok mu?',
            detail2: 'Şimdi kaydol',
            register_code_required: 'Lütfen davet kodunu girin',
            register_code_invalid: 'Lütfen doğru davet kodunu girin',
        },
        register: {
            createAccount: 'Hesap Oluştur',
            title2: 'AI destekli pazarlama araçlarıyla başlayın',
            getVerifyCode: 'Doğrulama kodu al',
            verificationCode: 'Doğrulama kodu',
            sendCode: 'Kod gönder',
            continue: 'Devam',
            detail1: 'Zaten hesabınız var mı?',
            detail2: 'Şimdi giriş yap',
            newPassword: 'Şifre',
            confirm: 'Şifreyi onayla',
            confirmCreate: 'Hesap oluştur',
            trash_can:
                'E-postayı gelen kutunuzda almadıysanız, lütfen spam klasörünüzü kontrol edin.',
        },
        findPassword: {
            forgotPassword: 'Şifremi unuttum',
            findBackPassword: 'Şifreyi kurtar',
            title: 'Doğrulama kodu ile şifre sıfırla',
            email: 'E-posta',
            sendCode: 'Kod gönder',
            resetPassword: 'Şifreyi sıfırla',
            detail1: 'Zaten hesabınız var mı?',
            detail2: 'Şimdi giriş yap',
            newPassword: 'Şifre',
            confirm: 'Şifreyi onayla',
            tip: 'Doğrulama kodu ile şifre sıfırlama, günde 5 kez ile sınırlı.',
        },
        rules: {
            email1: 'Lütfen e-posta adresini girin',
            email2: 'Lütfen geçerli bir e-posta adresi girin',
            verifyCode1: 'Lütfen davet kodunu girin',
            pwd1: 'Lütfen şifre girin',
            confirmPwd1: 'Şifreler eşleşmiyor',
            password1: 'Lütfen şifre onayını girin',
            verifyCode2: 'Lütfen doğrulama kodunu girin',
            verifyCode3: 'Lütfen doğru doğrulama kodunu girin',
            password2: 'Şifre boşluk içeremez',
            password3: 'Şifre uzunluğu yanlış',
            email_not_registered: 'E-posta kayıtlı değil',
            login_failed: 'Giriş başarısız, lütfen daha sonra tekrar deneyin',
            verifyCode_sent:
                'Doğrulama kodu gönderildi, lütfen e-postanızı kontrol edin',
            send_failed: 'Gönderim başarısız',
            email_registered: 'Bu e-posta zaten kayıtlı',
            register_success: 'Kayıt başarılı',
            register_failed:
                'Kayıt başarısız, lütfen daha sonra tekrar deneyin',
            reset_password_success: 'Şifre başarıyla sıfırlandı',
            reset_password_failed:
                'Şifre sıfırlama başarısız, lütfen daha sonra tekrar deneyin',
            login_popup_failed:
                'Google giriş penceresi açılamıyor, lütfen tekrar deneyin veya ağ bağlantısını kontrol edin',
            login_popup_blocked:
                'Giriş açılır penceresi engellendi, lütfen tarayıcınızda açılır pencerelere izin verin',
            google_login_not_supported: 'Google girişi henüz desteklenmiyor',
        },
    },
}
